export class Acceso {
    rolId : number;
    menuId : number;
    acceso : string;
    menuNombre: string;
    menuIdPadre: number;

    constructor(json? : any) {
        if (json != null) {
            this.rolId = json.rolId;
            this.menuId = json.menuId;
            this.acceso = json.acceso;
            this.menuNombre = json.menuNombre;
            this.menuIdPadre = json.menuIdPadre;
        }
    }

    // Utils
    static toArray(jsons : any[]) : Acceso[] {
        let accesoList : Acceso[] = [];
        if (jsons != null) {
            for (let json of jsons) {
                accesoList.push(new Acceso(json));
            }
        }
        return accesoList;
    }
}



// WEBPACK FOOTER //
// ./src/app/_seguridad/_acceso/acceso.ts